import { Injectable } from '@angular/core';

import { BestOddsGuaranteedToken, CriteriaType } from '../../../../reward-tokens.model';
import { hasBestOddsGuaranteeFlag, isValidSport } from '../../../../validators';
import { toBestOddsLikeFixtures } from '../../../betstation-reward-tokens.utils';
import { TokenPicksValidity, TokenValidationInput, TokensCriteriaValidatorBase, picksValidity } from '../../criteria-validator-base.service';

@Injectable()
export class SportsBestOddsGuaranteeValidator extends TokensCriteriaValidatorBase<BestOddsGuaranteedToken, CriteriaType> {
    override type = CriteriaType.Sports;

    constructor() {
        super();
    }

    isValid(token: BestOddsGuaranteedToken, context: TokenValidationInput): TokenPicksValidity {
        const fixtures = toBestOddsLikeFixtures(context);

        if (!fixtures.length) {
            return picksValidity(false, []);
        }

        const validPicksIds = fixtures
            .filter((fixture) => !!fixture && hasBestOddsGuaranteeFlag(fixture) && isValidSport(token, fixture))
            .map((fixture) => fixture!.pickId);

        return { isValid: validPicksIds.length > 0, validPicksIds };
    }
}
